import { createRouter, createWebHistory } from 'vue-router'
//import Home from '../views/Home.vue'
import CompaniesRoutes from './routes/v2/company'
import UsersRoutes from './routes/v2/users'
import MarkingList from './routes/v2/marking_list'
import TypesOfWork from './routes/v2/types_of_work'
import Aspects from './routes/v2/aspects'
import Events from './routes/v2/events'
import Corpstandart from './routes/v2/corpstandart'
import QuizAnswers from './routes/v2/quiz'
import Kcop from './routes/v2/kcop'
import expertsgroup from './routes/v2/expertsgroup'
import v2_main from './v2/main.js'


const routes = [
  ...CompaniesRoutes,
  ...UsersRoutes,
  ...MarkingList,
  ...TypesOfWork,
  ...Aspects,
  ...Events,
  ...Corpstandart,
  ...QuizAnswers,
  ...Kcop,
  ...expertsgroup,
  ...v2_main,
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "about" */ '../views/register.vue'),
  },
  {
    path: '/quiz',
    name: 'Quiz',
    component: () => import(/* webpackChunkName: "about" */ '../views/Quiz.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/',
    name: 'Main',
    component: () => import(/* webpackChunkName: "about" */ '../views/Main.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import(/* webpackChunkName: "about" */ '../views/account/account.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/account/change-password',
    name: 'Changepassword',
    component: () => import(/* webpackChunkName: "about" */ '../views/account/change-password.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/account/user-companies',
    name: 'UserCompanies',
    component: () => import(/* webpackChunkName: "about" */ '../views/account/user-companies.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  //AddUserToCompany
  {
    path: '/account/add-user-to-company',
    name: 'AddUserToCompany',
    component: () => import(/* webpackChunkName: "about" */ '../views/account/add-user-to-company.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  
  // positions
  {
    path: '/company/positions/:id',
    name: 'Positions',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/companies/positions/positions.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/company/positions/:id/new',
    name: 'NewPositions',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/companies/positions/new_positions.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  //Library/WebServer/Documents/projects/corpstandart/corpstandart-frontend/src/views/ user_passport/user_corpstandarts.vue
  {
    path: '/logout',
    name: 'Logout',
    component: () => import(/* webpackChunkName: "about" */ '../views/logout.vue'),
    meta: { 
      requiresAuth: true
    }
  }
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token') == null) {
      
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    } else {
      let user = JSON.parse(localStorage.getItem('user'))
      if(to.matched.some(record => record.meta.is_admin)) {
        if(user.is_admin == 1){
          next()
        }
        else{
          console.log(router.from, '--', router.to);
          next({ path: '/'})
        }
      }else {
        next()
      }
    }
  } else if(to.matched.some(record => record.meta.guest)) {
    if(localStorage.getItem('token') == null){
      next()
    }
    else{
      next({ path: '/'})
    }
  }else {
    next() 
  }
})

export default router